/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* custom js for multi column section */

const tabs = document.querySelectorAll(".new_multi_column_bottom_img");
const tabContents = document.querySelectorAll(".new_multi_block_text");
let priorActive = null;

tabs.forEach(tab => {
  tab.addEventListener("click", function () {
    // Remove 'active' class from all tabs and their content
    tabs.forEach(t => {
      t.classList.remove("active");
      t.parentElement.querySelector(".new_multi_block_text").classList.remove("active");
    });

    // If the clicked tab was the one previously active, leave it inactive
    if (priorActive === this) {
      priorActive = null;
    } else {
      // Add 'active' class to the clicked tab and its corresponding content
      this.classList.add("active");
      this.parentElement.querySelector(".new_multi_block_text").classList.add("active");
      priorActive = this;
    }
  });
});

/* custom js for section PDP stincky problem */
$(document).ready(function() {
  $('.problem-item').click(function() {
    $('.problem-item').removeClass('problem-active');
    $(this).addClass('problem-active');
  });
});

/* custom js for video list section */
$(document).on('click', '.section_video_list .play_icon', function(){
  $(this).addClass('hide');
  $(this).parents('.video').find('video').trigger('play');
});

/* marquee section */
var r = document.querySelector(':root');
if(document.querySelectorAll('.marquee_list').length) r.style.setProperty('--marquee-width', '-'+document.querySelector('.marquee_list .marque_list:first-child').clientWidth+'px');

/* logo list section slider */

$(document).ready(function(){
      if($('.home_logo_list .quick-links').length){
       var width = $(window).width(); 
          if (width <= 640) {
            $('.home_logo_list .quick-links').slick({
              slidesToShow: 3,
              slidesToScroll: 1,        
              infinite: true,
              autoplay: true,
              arrows: false,
              autoplaySpeed: 2000,
              speed: 1000
            });        
          }
        }
    });  

/* collection with image section mobile slider */
if($(window).width() < 640) {
  if($(".multicolumn_slide .new_multi_column_wrap").length){
    $('.multicolumn_slide .new_multi_column_wrap').each(function(slider___slider) {
        $(this).slick({
        dots:true,
        appendDots:  $(this).parents('.multicolumn_slide').find('.slider_dot'),
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: $(this).parents('.multicolumn_slide').find('.slider_arrow .slider_left_arrow'),
        nextArrow: $(this).parents('.multicolumn_slide').find('.slider_arrow .slider_right_arrow'),
          responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
      });
    });
  }
}
// review block js on new product page
$(document).on('click', '.header-featured-review .h-featured-img-col.video .icon-video-play', function() {
  var videoElement = $(this).parents('.video').find('video').get(0);
  videoElement.play();
  $(this).hide();
});

$(document).on('click', '.header-featured-review .h-featured-img-col.video video', function() {
  var select_video = $(this).get(0);
  if (select_video.paused) {
    select_video.play();
    $(select_video).parents('.video').find('.icon-video-play').hide();
  } else {
    select_video.pause();
    $(select_video).parents('.video').find('.icon-video-play').show();
  }
});

 


